import * as z from 'zod';
import { parseAmountBound } from './panel-params';

/**
 * Un estremo di «Importo» nell'URL (`amountMin` / `amountMax`, valore
 * assoluto in euro). TanStack Router consegna `?amountMin=10` già come
 * numero; qualunque altra cosa (testo, negativo, `NaN`) si scarta invece di
 * abbattere la route sull'ErrorFallback o arrivare al backend come 400.
 * Gli estremi invertiti si raddrizzano dopo, in `parseAmountRange`.
 */
export const optionalAmountParam = z
  .unknown()
  .optional()
  .transform(parseAmountBound);

/** I due estremi del filtro «Importo», da spargere in un `validateSearch`. */
export const amountSearchParams = {
  amountMin: optionalAmountParam,
  amountMax: optionalAmountParam,
};
